import { getUserInfo, loginByUsername, logout } from '@/api/login'
import { identifyUser, resetUser } from '@/telemetry/posthogTelemetry'
import { getAuthData, getToken, removeAuthData, removeToken, setAuthData, setToken } from '@/utils/auth'

const user = {
  state: {
    status: '',
    token: getToken(),
    name: '',
    roles: [],
    notificationChannels: [],
    authData: getAuthData()
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_AUTH_DATA: (state, authData) => {
      state.authData = authData
    },
    SET_NOTIFICATION_CHANNELS: (state, notificationChannels) => {
      state.notificationChannels = notificationChannels
    }
  },

  actions: {
    // User name login
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password)
          .then(response => {
            commit('SET_TOKEN', response.data.accessToken)
            commit('SET_AUTH_DATA', response.data)
            setToken(response.data.accessToken)
            setAuthData(response.data)
            identifyUser({ username })
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // Get user information
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token)
          .then(response => {
            if (!response) {
              // Since mockjs doesn't support custom status codes this can only be hacked
              reject('error')
            }
            commit('SET_ROLES', response.data.roles)
            commit('SET_NOTIFICATION_CHANNELS', response.data.notificationChannels ?? [])
            commit('SET_NAME', response.data.username)
            commit('SET_STATUS', response.data.enabled)
            identifyUser({
              username: response.data.username,
              roles: response.data.roles
            })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // Sign out
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_NOTIFICATION_CHANNELS', [])
            commit('SET_AUTH_DATA', {})
            removeToken()
            removeAuthData()
            resetUser()
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_NOTIFICATION_CHANNELS', [])
        commit('SET_AUTH_DATA', {})
        removeToken()
        removeAuthData()
        resetUser()
        resolve()
      })
    },

    // Dynamically modify permissions
    ChangeRoles({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          resolve()
        })
      })
    },

    ChangeStatus({ commit }, status) {
      return new Promise((resolve, reject) => {
        commit('SET_STATUS', status)
        getUserInfo()
          .then(response => {
            if (!response) {
              reject('error')
            }
            commit('SET_STATUS', response.data.enabled)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    SetAuthData({ commit }, authData) {
      return new Promise(resolve => {
        commit('SET_AUTH_DATA', authData)
        commit('SET_TOKEN', authData.accessToken)
        setToken(authData.accessToken)
        resolve()
      })
    }
  }
}

export default user
